<template>
  <div>
    <SetupOfficials
      v-if="showOfficials"
      @next="setView('tournament')"
    />
    <SetupTournament
      v-if="showTournament"
      @back="setView('officials')"
      @next="setView('matchFights')"
    />
    <SetupMatchFights
      v-if="showMatchFights"
      @back="setView('tournament')"
      @next="setView('schedule')"
    />
    <SetupSchedule
      v-if="showSchedule"
      @back="setView('matchFights')"
    />
  </div>
</template>

<script>
import SetupOfficials from '@/components/Setup/SetupOfficials.vue';
import SetupTournament from '@/components/Setup/SetupTournament.vue';
import SetupMatchFights from '@/components/Setup/SetupMatchFights.vue';
import SetupSchedule from '@/components/Setup/SetupSchedule.vue';

export default {
  name: 'Setup',
  components: {
    SetupSchedule, SetupMatchFights, SetupOfficials, SetupTournament,
  },
  data() {
    return {
      view: 'officials',
    };
  },
  methods: {
    setView(newView) { this.view = newView; },
  },
  computed: {
    showOfficials() { return this.view === 'officials'; },
    showTournament() { return this.view === 'tournament'; },
    showMatchFights() { return this.view === 'matchFights'; },
    showSchedule() { return this.view === 'schedule'; },
  },
};
</script>

<style scoped>

</style>
